<template>
    <CollapsibleWidget>
        <template #name>After Effects Fonts</template>
        <template #controls>
            <Icon type="md-trash" @click.exact.stop="resetStyles('FontStyle')" />
        </template>
        <div class="font-style">
            <EditableSettingsControl :title="camelToUpperCase(EditableSettingProperty.Font)">
                <template #button>
                    <div class="editable-settings-item">
                        <FontType width="20" height="20" />
                    </div>
                </template>

                <template #value>
                    <EditableSettingsTextInput
                        v-model="font"
                        suffix="name"
                        :show-suffix="true"
                        :placeholder="getPlaceholderValue(EditableSettingProperty.Font)"
                    />
                </template>
            </EditableSettingsControl>
        </div>

        <EditableSettingsControl :title="camelToUpperCase(EditableSettingProperty.FontSize)">
            <template #button>
                <div class="editable-settings-item">
                    <LetterSize width="16" height="16" />
                </div>
            </template>

            <template #value>
                <EditableSettingsNumberInput
                    v-model="fontSize"
                    :show-suffix="true"
                    :placeholder="getPlaceholderValue(EditableSettingProperty.FontSize)"
                />
            </template>
        </EditableSettingsControl>
    </CollapsibleWidget>
</template>

<script lang="ts" setup>
import type { CSSSettings } from "hoxton-types";

import LetterSize from "@/assets/text-editor/letter-size.svg";
import FontType from "@/assets/text-editor/type.svg";

import EditableSettingsControl from "@/components/Campaign/SettingsPane/EditableSettingsControl.vue";
import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";
import EditableSettingsTextInput from "@/components/Campaign/SettingsPane/EditableSettingsTextInput.vue";
import EditableSettingsNumberInput from "@/components/Campaign/SettingsPane/EditableSettingsNumberInput.vue";

import { useEditableSettings } from "@/composables/useEditableSettings";

import { camelToUpperCase } from "@/utils";
import { EditableSettingProperty } from "@/enums/editables";

const emit = defineEmits<(e: "onSettingsChange", value: CSSSettings | null) => void>();

const onSettingsChange = (settings: CSSSettings | null) => {
    emit("onSettingsChange", settings);
};

const { fontSize, font, getPlaceholderValue, resetStyles } = useEditableSettings({
    onSettingsChange
});
</script>
